import { ref } from "vue"

// The "Dodeli" (assign) flow, kept out of the list components the way Notification is: a list only
// says WHICH order its admin wants assigned, App.js renders the one modal, and every list reloads
// through assignmentsDone once an assignment lands (a list that is not the one that opened the
// modal may still be showing the order's old owner).
const target = ref(null)
const done = ref(0)

export const assignTarget = target
export const assignmentsDone = done

export const openAssign = (workOrder) => (target.value = workOrder)
export const closeAssign = () => (target.value = null)
export const finishAssign = () => {
  target.value = null
  done.value++
}
